(function(w, d) {
    var globalCallbackChannel = 'recaptcha.callback.';;

    // Check if PubSub engine was loaded
    var pubSub = w.PubSub;
    if (typeof pubSub !== 'object' || !pubSub) {
        console.error('PubSub library is not loaded');
        return;
    }

    w.recaptcha_onload = function () {
        return pubSub.publish(globalCallbackChannel + 'loaded');
    };

    w.recaptcha_loading = false;

    w.recaptcha_load = function () {
        if (w.grecaptcha || w.recaptcha_loading === true) {
            return;
        }

        w.recaptcha_loading = true;

        const src = "https://www.google.com/recaptcha/api.js?onload=recaptcha_onload&render=explicit";
        const script = d.createElement('script');
        script.src = src;
        d.body.appendChild(script);
    }
})(window, document);